import axios from "../api/axios";

export async function loadRecordSnapshot(type, id, params) {
  const path = { report: "service/reports", order: "orders", calculation: "offer_calculations" }[type];
  const response = await axios.get(`/${path}/${id}`, { params });
  const data = response.data?.data || response.data;
  const version = type === "calculation" ? data?.lock_version : data?.edit_version;
  if (data?.error || data?.errors || data?.problem || String(data?.id) !== String(id) || version == null) {
    throw data || new Error("Missing record snapshot");
  }
  return data;
}
